import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { withMetaTags } from '../../components/MetaTags/MetaTags';
import './QuizIntro.scss';

const steps = [
  {
    number: 1,
    title: 'Match',
    copy: 'Tell us what you like.',
  },
  {
    number: 2,
    title: 'Choose',
    copy: 'Pick your first coffee.',
  },
  {
    number: 3,
    title: 'Restock',
    copy: 'Your scale times refills.',
  },
];

const QuizIntroComponent = () => (
  <div className="page-quiz-intro">
    <header className="quiz-intro-header">
      <Container>
        <Link to="/coffee" className="quiz-intro-logo" aria-label="Bottomless coffee">
          <img src="/images/Bottomless-logo-blue.png" alt="Bottomless" />
        </Link>
      </Container>
    </header>
    <main className="quiz-intro-main">
      <Container>
        <div className="quiz-intro-grid">
          <div className="quiz-intro-image-wrap">
            <img
              src="https://bottomless.imgix.net/assets/quiz-intro.png?auto=compress,format&w=420"
              srcSet="https://bottomless.imgix.net/assets/quiz-intro.png?auto=compress,format&w=420 420w, https://bottomless.imgix.net/assets/quiz-intro.png?auto=compress,format&w=840 840w"
              sizes="(max-width: 767px) 100vw, 420px"
              alt="Coffee bags and smart scales"
              className="quiz-intro-image"
            />
          </div>
          <section className="quiz-intro-content" aria-labelledby="quiz-intro-title">
            <div className="quiz-intro-eyebrow">Matched to your taste</div>
            <h1 id="quiz-intro-title">
              Fresh coffee that
              <br className="d-none d-md-block" />
              reorders itself.
            </h1>
            <p className="quiz-intro-copy">
              Take our quiz to build a custom rotation of fresh coffee, matched to your taste. Choose your first bag;
              then, your smart scale times the next one.
            </p>
            <div className="quiz-intro-steps">
              {steps.map(step => (
                <div className="quiz-intro-step" key={step.number}>
                  <div className="quiz-intro-step-number">{step.number}</div>
                  <div className="quiz-intro-step-title">{step.title}</div>
                  <div className="quiz-intro-step-copy">{step.copy}</div>
                </div>
              ))}
            </div>
            <div className="quiz-intro-actions">
              <Link to="/filter_checkout" className="btn btn-primary btn-lg quiz-intro-button">
                Start the quiz
              </Link>
              <span className="quiz-intro-note">Takes less than a minute.</span>
            </div>
          </section>
        </div>
      </Container>
    </main>
  </div>
);

export const QuizIntroPage = withMetaTags({
  title: 'Bottomless: Coffee Quiz',
  description: 'Build a custom fresh coffee rotation matched to your taste.',
})(QuizIntroComponent);
